<style scoped lang="stylus">
    @import '../../assets/css/theme.styl'
    .my {
        .info {
            padding 0 10px
            color #666
            .con {
                background linear-gradient(to right, baseConBackColor, #434343)
                height 100px
                text-align left
                padding 0 20px
                border-radius 6px
            }
            .user-icon {
                font-size 32px
                /*padding 0 20px*/
            }

            .arrow-icon {
                font-size 20px
                padding 20px
                color #999
            }

            .desc-box {
                flex 1
                margin-left: 20px
                color: #fff
                font-size: 16px
            }
            .user-avatar {
                background-color: #fff
                border-radius 100%
                height 56px
                width 56px
            }

        }
        .list {
            margin-top: 20px
            .van-icon {
                color: #999
            }
            &:after {
                border none
            }
            .van-cell:after {
                border-color #363636
            }
            .van-cell {
                background-color: baseConBackColor
            }
        }
    }
</style>

<template>
    <div class="my cus-cell">
        <div class="info" @click="goSettingPage">
            <div data-flex="dir:left cross:center" class="con">
                <div class="user-avatar" data-flex="cross:center main:center">
                    <van-icon name="user-o" class="user-icon"/>
                </div>
                <div class="desc-box">
                    <p>{{userInfo.name}}</p>
                </div>
            </div>
            <!--<van-icon name="arrow" class="arrow-icon"/>-->
        </div>

        <van-cell-group class="list">
            <van-cell v-for="(item, index) in list" :key="index" :title="item.title" :icon="item.icon" is-link
                      :to="{name: item.routerName}" />
        </van-cell-group>

        <div class="bt-cus-box">
            <van-button type="danger" size="large" @click="logout">退出登录</van-button>
        </div>
    </div>
</template>

<script>
    import {setToken} from "@/util";

    export default {
        props: [],
        components: {},
        data() {
            return {
                list: [
                    {
                        title: '修改密码',
                        icon: 'eye-o',
                        routerName: 'my-pass-edit',
                    },
                    {
                        title: '更换手机',
                        icon: 'edit',
                        routerName: 'my-change-mobile',
                    }
                ]
            };
        },
        created() {

        },
        mounted() {

        },
        computed: {
            userInfo() {
                return this.$store.state.userInfo
            }
        },
        watch: {},
        methods: {
            logout() {
                setToken('')
                this.$store.commit('setUserInfo', {data: ''});
                this.$router.replace({name: 'login'})
            },
            goSettingPage() {

            },

        },
    };
</script>
